import React from 'react';
import './header.css';
import headbg from '../assets/headbg.svg';

const Header = () => {
  return (
    <div className='duf__header section__padding' id='home'>
      <div className="duf__header-content">
        <h1 className="duf__text"><span>W</span>e P<span>r</span>ovide <br /> Us<span>e</span>ful Too<span>l</span>s</h1>
        <div className="duf__header-image">
          <img src={headbg} alt="headbg"/>
        </div> 
    </div>

</div>
  )
}

export default Header;